<header>
  <nav class="sideNav">
    <a href="#">
      <div class="logo">
        <svg
          width="38"
          height="45"
          viewBox="0 0 38 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d)">
            <path
              d="M7.31869 10.664C7.27069 10.376 7.24669 10.016 7.24669 9.584C7.24669 9.104 7.24669 8.576 7.24669 8C7.24669 6.704 7.15069 5.552 6.95869 4.544C6.76669 3.536 6.67069 2.816 6.67069 2.384C6.67069 1.568 7.46269 1.016 9.04669 0.727999C10.7267 0.439997 13.5587 0.295996 17.5427 0.295996H19.4867C27.4067 0.295996 32.3267 2.696 34.2467 7.496C34.5347 8.12 34.7267 8.816 34.8227 9.584C34.9667 10.352 35.0387 11.192 35.0387 12.104C35.0387 13.976 34.6787 15.656 33.9587 17.144C33.2387 18.584 32.1587 20.072 30.7187 21.608C29.2307 23.24 28.4867 24.512 28.4867 25.424C28.4867 25.952 28.7507 26.816 29.2787 28.016C29.8067 29.168 30.4307 30.392 31.1507 31.688C31.8707 32.984 32.5907 34.208 33.3107 35.36C34.0787 36.512 34.6787 37.304 35.1107 37.736C36.7907 39.512 37.6307 40.712 37.6307 41.336V41.912C37.6307 42.872 36.8627 43.352 35.3267 43.352H34.6067C33.1667 43.352 31.8707 42.752 30.7187 41.552C30.0467 40.88 28.6067 38.672 26.3987 34.928C25.2947 33.056 24.3827 31.592 23.6627 30.536C22.9907 29.432 22.3907 28.616 21.8627 28.088C21.3827 27.512 20.8787 27.152 20.3507 27.008C19.8707 26.864 19.2467 26.792 18.4787 26.792C16.9427 26.792 15.8627 27.416 15.2387 28.664C14.6627 29.864 14.3747 31.28 14.3747 32.912C14.3747 34.496 14.5187 35.984 14.8067 37.376C15.0947 38.72 15.2387 39.512 15.2387 39.752C15.2387 41 14.7347 41.912 13.7267 42.488C12.7667 43.016 11.5907 43.28 10.1987 43.28C8.75869 43.28 7.65469 42.992 6.88669 42.416C6.11869 41.84 5.73469 40.856 5.73469 39.464C5.73469 38.888 5.97469 38.096 6.45469 37.088C6.93469 36.08 7.24669 35.072 7.39069 34.064C7.43869 33.584 7.46269 32.816 7.46269 31.76C7.51069 30.704 7.53469 29.336 7.53469 27.656V18.872L7.46269 17.936V16.136L7.31869 10.664ZM16.8227 21.824H17.6147C20.8787 21.824 23.4707 21.08 25.3907 19.592C27.3107 18.056 28.2707 16.016 28.2707 13.472V11.96C28.2707 9.704 27.5267 7.928 26.0387 6.632C24.5987 5.288 22.5827 4.616 19.9907 4.616H18.9107L17.6147 4.76C16.7027 4.76 15.8867 4.904 15.1667 5.192C14.4947 5.48 14.1587 6.176 14.1587 7.28L14.0147 9.224V11.528L13.9427 12.392V18.512C13.9427 19.904 14.1107 20.816 14.4467 21.248C14.7827 21.632 15.5747 21.824 16.8227 21.824Z"
              fill="#FC766A"
            />
          </g>
          <defs>
            <filter
              id="filter0_d"
              x="0.73468"
              y="0.296021"
              width="36.896"
              height="44.056"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dx="-5" dy="1" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.356863 0 0 0 0 0.517647 0 0 0 0 0.694118 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </a>
    <div class="links">
      <ul class="unordered">
        <li id="0" name="Home">
          <a routerLink="/"
            ><i
              class="fas fa-home"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: true }"
            ></i
            ><span class="linkName"></span
          ></a>
        </li>
        <li id="1" name="About Me">
          <a routerLink="/aboutme"
            ><i
              class="far fa-user"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: true }"
            ></i
            ><span class="linkName"></span
          ></a>
        </li>
        <li id="2" name="Skills">
          <a routerLink="/skills"
            ><i
              class="far fa-keyboard"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: true }"
            ></i
            ><span class="linkName"></span
          ></a>
        </li>
        <li id="3" name="Work">
          <a routerLink="/work"
            ><i
              class="far fa-save"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: true }"
            ></i
            ><span class="linkName"></span
          ></a>
        </li>
        <li id="4" name="Contact Me">
          <a routerLink="/contactme"
            ><i
              class="far fa-envelope"
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{ exact: true }"
            ></i
            ><span class="linkName"></span
          ></a>
        </li>
      </ul>
      <div class="social-media">
        <i class="fas fa-angle-down" (click)="socialMedia()"></i>
        <i class="fas fa-angle-up" (click)="socialMedia()"></i>
        <div class="media-tray">
          <div class="row-1">
            <div class="media">
              <a href="https://www.linkedin.com/in/rahilhastu/" target="_blank"
                ><i class="fab fa-linkedin-in"></i
              ></a>
            </div>
            <div class="media">
              <a href="https://github.com/rahilhastu" target="_blank"
                ><i class="fab fa-github"></i
              ></a>
            </div>
          </div>
          <div class="row-2">
            <div class="media">
              <a
                href="https://stackoverflow.com/users/8811767/rahil-hastu"
                target="_blank"
                ><i class="fab fa-stack-overflow"></i
              ></a>
            </div>
            <div class="media">
              <a href="https://twitter.com/HastuRahil" target="_blank"
                ><i class="fab fa-twitter"></i
              ></a>
            </div>
          </div>
          <div class="row-3">
            <div class="media">
              <a href="https://www.facebook.com/rahil.hastu/" target="_blank"
                ><i class="fab fa-facebook-f"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
<!-- <div class="parent"> -->
<a
  class="noClass"
  href="https://gist.github.com/rahilhastu/7e1b6d851f5960d8c54a222fada9cd0e"
  target="_blank"
  ><h4 class="ribbon">Google Summer of Code 2023</h4></a
>
<!-- </div> -->
<router-outlet></router-outlet>
